import { ArrowDropDown as ArrowDropDownCore } from '@material-ui/icons';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

type MenuListProps = {
  open: boolean;
};

type ButtonType = {
  open: boolean;
};

type IconType = {
  color: string;
};

type ArrowIconType = {
  open: boolean;
};

type MenuItemProps = {
  isSelected: boolean;
};

type SelectedSenderProps = {
  allowGrowOnHover: boolean;
};

export const ArrowDropDown = lib.styled(ArrowDropDownCore)<IconType>`
  display: inline-block;
  color: ${colors.darkGray07};
  margin-right: 5px;
  transform: ${(props: ArrowIconType) =>
    props.open ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const Container = lib.styled.div`
  button {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border: unset;
    padding: 5px;
    border-radius: 7px;
  }
`;

export const Menu = lib.styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
`;

export const Button = lib.styled.button<ButtonType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 7px 10px 7px 10px;
    gap: 10px;
    color: ${colors.black};
    background-color: ${colors.white};
    border: ${(props: ButtonType) =>
      !props.open ? `1px solid ${colors.lightGray17}` : 'none'};
    border-radius: 10px;
    cursor: pointer;
    font-family: 'Nunito';
    font-size: 14px;
    box-shadow: ${(props: ButtonType) =>
      props.open ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none'};  
`;

export const SelectedSender = lib.styled.span<SelectedSenderProps>`
    margin-left: 5px;
    color: ${colors.lightGray13};
    font-size: ${fonts.placeholder}px;
    font-style: italic;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 350px;
      
    ${(props: any) =>
      props.allowGrowOnHover &&
      `
        &:hover {
          overflow: unset;
          white-space: normal;
          font-size: ${fonts.default}px;
      }`}
`;

export const MenuList = lib.styled.ul<MenuListProps>`
    display: ${(props: MenuListProps) =>
      props.open ? 'inline-block' : 'none'};
    position: absolute;
    top: 100%;
    width: 100%;
    background-color: white;
    margin-top: 7px;
    list-style: none;
    z-index: 100;
    border-radius: 7px;
    gap: 3px;
    max-height: 340px;
    overflow: scroll;
    opacity: ${(props: MenuListProps) => (props.open ? 1 : 0)};
    transition: opacity 0.5s ease, transform 0.5s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    ::-webkit-scrollbar {
      display: none;
    }
`;

export const MenuItem = lib.styled.li<MenuItemProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 7px;
    font-size: 14px;
    font-family: Nunito;
    font-weight: ${(props: MenuItemProps) =>
      props.isSelected ? 'bold' : 'normal'};
    color: ${colors.darkGray11};
    height: 25px;
    margin: 3px;
    padding: 5px;
    cursor: pointer;

    :hover {
        background-color: ${colors.lightGray};
    }
`;
